import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import { FuseTranslationLoaderService } from 'app/services/translation-loader.service';
import { LocalizedStringPipeModule } from '~app/shared/localized-string-pipe/localized-string-pipe.module';
import { ShoppingCartModule } from '~app/shopping-cart/shopping-cart.module';
import { locale as billsInvoicesEnglish } from '../billsInvoices/i18n/en';
import { locale as billsInvoicesFrench } from '../billsInvoices/i18n/fr';
import { MaterialModule } from '../shared/material.module';
import { PaymentState } from './store/payment.state';
import { PaymentComponent } from './payment.component';

@NgModule({
  declarations: [PaymentComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    MatDialogModule,
    TranslateModule,
    ShoppingCartModule,
    LocalizedStringPipeModule,
    NgxsModule.forFeature([PaymentState]),
  ],
  exports: [PaymentComponent],
})
export class PaymentModule {
  constructor(translationLoader: FuseTranslationLoaderService) {
    translationLoader.loadTranslations(billsInvoicesEnglish, billsInvoicesFrench);
  }
}
